import { render, staticRenderFns } from "./checkUpOpinion.vue?vue&type=template&id=35d37b2e"
import script from "./checkUpOpinion.vue?vue&type=script&lang=js"
export * from "./checkUpOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d37b2e')) {
      api.createRecord('35d37b2e', component.options)
    } else {
      api.reload('35d37b2e', component.options)
    }
    module.hot.accept("./checkUpOpinion.vue?vue&type=template&id=35d37b2e", function () {
      api.rerender('35d37b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpOpinion.vue"
export default component.exports